import { makeStyles } from '@material-ui/core'
import React from 'react'
import EmptyStateIcon from './EmptyStateIcon'
import DazzedHeadingForGrid from 'components/common/text/DazzedHeadingForGrid'
import { useTranslation } from 'react-i18next'
import ConfettyIcon from './ConfettyIcon'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '50%',
    paddingBottom: 0,
    position: 'relative'
  },
  title: {
    color: '#A6B5D2'
  }
}))

const NeedsAttentionEmptyState = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <div className={classes.root}>
      <ConfettyIcon style={{ position: 'absolute', top: -65 }} />
      <DazzedHeadingForGrid bold xs={16} className={classes.title}>
        {t('pages.copilotControl.widgets.needsAttention.emptyState.title1')}
      </DazzedHeadingForGrid>
      <DazzedHeadingForGrid bold xs={16} className={classes.title}>
        {t('pages.copilotControl.widgets.needsAttention.emptyState.title2')}
      </DazzedHeadingForGrid>
      <EmptyStateIcon style={{ marginTop: 30 }} />
    </div>
  )
}

export default NeedsAttentionEmptyState
